(function () {
  'use strict';
  function labelMenu(root) {
    root.querySelectorAll('.mm-next').forEach(function (link) {
      if (link.hasAttribute('aria-label')) return;
      var item = link.parentElement;
      var title = item && item.querySelector('a:not(.mm-next),span');
      var text = title && title.textContent.trim();
      if (text) link.setAttribute('aria-label', text);
    });
  }
  function init() {
    var menu = document.getElementById('mobile_menu');
    if (!menu) return;
    labelMenu(menu);
    new MutationObserver(function (mutations) {
      if (mutations.some(function (entry) { return entry.addedNodes.length; })) labelMenu(menu);
    }).observe(menu, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
}());
